import { Component, EventEmitter, Input, OnDestroy, OnInit, Output,ElementRef,ViewChild, ChangeDetectionStrategy} from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from '../../block-ui';
import { RbacService } from '@stg-js-ngx-core/oauth';
import { Subscription } from 'rxjs';
import { HospitalsGridModalComponent } from './hospitals-grid-modal/hospitals-grid-modal.component';
import { MmtCommonService } from '../../services/mmt-common.service';
import { HospitalAdministrationService } from '../../../hospital-administration/hospital-administration.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
  selector: 'hospital-selector',
  templateUrl: './hospital-selector.component.html',
  styleUrls: ['./hospital-selector.component.scss']
})
export class HospitalSelectorComponent implements OnInit, OnDestroy {
  hospitalName: string = null;
  @Input() disabled: boolean = false;
  @Input() _onlyActive: boolean = false;
  @Input() globalUpdate: boolean = true;
  @Output() hospitalSelected: EventEmitter<any> = new EventEmitter<any>();
  hospitalChangeSubscription: Subscription;
  roleChanged: boolean = false;
  @BlockUI() blockUI: NgBlockUI;

  private modalRef: NgbModalRef = null;

  @ViewChild('selectorRef') selectorRef: ElementRef;

  constructor(private modalService: NgbModal,
              private commonService: MmtCommonService,
              private hospitalAdminService: HospitalAdministrationService,
              private rbacService: RbacService
  ) { }

  ngOnInit(): void {
    this.hospitalChangeSubscription = this.commonService.hospitalChange
      .subscribe(res => {
        if (res) {
          this.hospitalName = res.costCenter + ' - ' + res.name;
          this.commonService.hospital = res;
        } else if (
          !this.roleChanged && ( !this.rbacService.allRoles ||
            (this.rbacService.allRoles &&  !this.rbacService.allRoles.filter(role => role.role_name === 'System Admin').length)
          )
        ){
          this.roleChanged = false;
          this.getHospitals();
        }

        if(this.roleChanged) {
          this.roleChanged = false;
        }
      });

    this.rbacService.roleChangeObservable.subscribe(() => {
      this.roleChanged = true;
      this.commonService.hospitalChange.next(null);
      this.commonService.hospital = null;
    });
  }

  openHospitalSelect() {
    // The click lives on the whole mat-form-field, so a stray second click would stack an
    // identical modal on top and force the user to cancel twice.
    if (this.disabled || this.modalRef) {
      return;
    }
    this.selectorRef.nativeElement.blur();
    const modalRef = this.modalService.open(HospitalsGridModalComponent, {
      size: 'lg', backdrop : 'static',
      keyboard : false
    });
    this.modalRef = modalRef;

    modalRef.componentInstance.onlyActive = this._onlyActive;

    modalRef.result.then(res => {
      this.modalRef = null;
      if (res) {
        this.hospitalName = res.costCenter + ' - ' + res.name;
        if (this.globalUpdate) {
          this.commonService.hospitalChange.next(res);
        }
        this.hospitalSelected.emit(res);
      }
    }, () => {
      // dismissed via the X - ngb rejects, which would otherwise surface as "ERROR null"
      this.modalRef = null;
    });
  }

  getHospitals() {
    this.blockUI.start();
    this.hospitalAdminService.getHospitalsByUserName(this.commonService.getEmail())
      .subscribe(res => {
        this.blockUI.stop();
        if (res && res.data && res.data.length && res.data.length === 1 && res.data[0].isActive) {
          this.hospitalName = res.data[0].costCenter + ' - ' + res.data[0].name;
          if (this.globalUpdate) {
            this.commonService.hospitalChange.next(res.data[0]);
          }
          this.hospitalSelected.emit(res.data[0]);
        }
      },error => {
        this.blockUI.stop();
        console.error(error);
      });
  }

  ngOnDestroy(): void {
    if ( this.hospitalChangeSubscription ) {
      this.hospitalChangeSubscription.unsubscribe();
    }
  }

}
